import { render, staticRenderFns } from "./QuestionCall.vue?vue&type=template&id=337d46f4"
import script from "./QuestionCall.vue?vue&type=script&lang=js"
export * from "./QuestionCall.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports